import React, { useState } from "react";

import ItmsChallan from "../../masters/dailyentry/Index";
import { LicenseTypes, PageFrom } from "../../../../../utils/Enum.types";
import { CustomModal } from "../../../../../utils/UtilFunctions";
import { ViewModalStyles } from "../../../../../styles/CustomModalStyles";

const Challans = () => {
const[challanModal,setChallanModal]=useState(false)
  return (
    <div className="d-challans">
      {/* <div className="row g-0 d-challans__flex">
        <div className="col">
          <b className="d-main-page__block--title">Challans</b>
        </div>
        <div className="col-3">
          <Select>
            <option>Daily</option>
            <option>Monthly</option>
            <option>Yearly</option>
          </Select>
        </div>
      </div>
      <div className="d-challans__tableblock">
        <StyledDatagrid
          columns={columns}
          rows={rows}
          rowHeight={TABLE_ROW_HEIGHT}
          disableRowSelectionOnClick
          hideFooter
        />
      </div> */}
      <ItmsChallan NavType={LicenseTypes.NONE} pageForm={PageFrom.DASHBOARD} />
      <button 
      className="d-main-page__block--bottom--view"
      onClick={()=>setChallanModal(!challanModal)}
      >View All</button>


        <CustomModal
        style={ViewModalStyles}
        isOpen={challanModal}
        onRequestClose={() => setChallanModal(!challanModal)}
        contentComponent={
          <>
           <ItmsChallan NavType={LicenseTypes.NONE} pageForm={PageFrom.MODAL} setModalFlag={setChallanModal} />
          </>
        }
      />
    </div>
  );
};

export default Challans;
